import { withIconProps } from "./withIconProps";
import Check from "./icon-check.svg?react";
import Chevron from "./icon-chevron.svg?react";
import Circle from "./icon-circle.svg?react";
import Comment from "./icon-comment.svg?react";
import Document from "./icon-document.svg?react";
import Eye from "./icon-eye.svg?react";
import Heart from "./icon-heart.svg?react";
import Minus from "./icon-minus.svg?react";
import Pin from "./icon-pin.svg?react";
import PlusWithCircle from "./icon-plus-with-circle.svg?react";
import Plus from "./icon-plus.svg?react";
import Point from "./icon-point.svg?react";
import Posnts from "./icon-posnts.svg?react";
import Share from "./icon-share.svg?react";
import Star from "./icon-star.svg?react";
import Warning from "./icon-warning.svg?react";
import Picture from "./icon-picture.svg?react";
import Cross from "./icon-cross.svg?react";
import Post from "./icon-post.svg?react";
import Series from "./icon-series.svg?react";
import Search from "./icon-search.svg?react";
import ProfileIcon from "./icon-profile-img-sm.svg?react";
export const IconCheck = withIconProps(Check);
export const IconChevron = withIconProps(Chevron);
export const IconCircle = withIconProps(Circle);
export const IconComment = withIconProps(Comment);
export const IconDocument = withIconProps(Document);
export const IconEye = withIconProps(Eye);
export const IconHeart = withIconProps(Heart);
export const IconMinus = withIconProps(Minus);
export const IconPin = withIconProps(Pin);
export const IconPlusWithCircle = withIconProps(PlusWithCircle);
export const IconPlus = withIconProps(Plus);
export const IconPoint = withIconProps(Point);
export const IconPosnts = withIconProps(Posnts);
export const IconShare = withIconProps(Share);
export const IconStar = withIconProps(Star);
export const IconWarning = withIconProps(Warning);
export const IconPicture = withIconProps(Picture);
export const IconCross = withIconProps(Cross);
export const IconPost = withIconProps(Post);
export const IconSeries = withIconProps(Series);
export const IconSearch = withIconProps(Search);
export const IconProfileIcon = withIconProps(ProfileIcon);
